import React from 'react'
import Link from '../Link'
import { startsWith } from 'lodash'

import './styles.scss'

const ReadMoreButton = (props) => (<div className="ReadMoreButton">
	<Link to={props.to} className="ReadMoreButton-Link">
		{ props.children }
	</Link>
</div>)

export default ReadMoreButton




// WEBPACK FOOTER //
// ./src/components/ReadMoreButton/index.js